import { ISelect } from './shared';

export const profiles: ISelect[] = [
    {
        id: 2,
        name: 'agent',
    },
    {
        id: 3,
        name: 'backoffice',
    },
    {
        id: 4,
        name: 'supervisor',
    },
    {
        id: 5,
        name: 'formador',
    },
    {
        id: 6,
        name: 'calidad',
    },
    {
        id: 7,
        name: 'cliente',
    },
    {
        id: 8,
        name: 'supervisor-junior',
    },
    {
        id: 9,
        name: 'agente-conmutador',
    },
    {
        id: 10,
        name: 'backoffice-cotizador',
    },
];

export const isTrainerOrQuality = (type: string) =>
    type === 'formador' || type === 'calidad';

export const isSupervisor = (type: string) => type === 'supervisor';

export const isSwitchAgent = (type: string) => type === 'agente-conmutador';

export const isOnlyViewProfile = (type: string) =>
    type === 'formador' ||
    type === 'calidad' ||
    type === 'cliente' ||
    type === 'supervisor-junior';

export const isOperativeProfile = (type: string) =>
    type === 'agent' ||
    type === 'backoffice' ||
    type === 'backoffice-cotizador';
